(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['exports'], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports);
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports);
        global.pexui = mod.exports;
    }
})(this, function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.resetLocales = resetLocales;
    exports.setCurrentLocale = setCurrentLocale;
    exports.getCurrentLocaleUrl = getCurrentLocaleUrl;
    exports._n = _n;
    exports.setCustomTextProps = setCustomTextProps;
    exports.extend = extend;
    exports.willChange = willChange;
    exports.endsWith = endsWith;
    exports.joinUrl = joinUrl;
    exports.joinIfAbsent = joinIfAbsent;
    exports.parseHeaders = parseHeaders;
    exports.getErrorInResponse = getErrorInResponse;
    exports.ajax = ajax;
    exports.upload = upload;
    exports.download = download;
    exports.insertStylesheetLink = insertStylesheetLink;
    exports.insertScriptTag = insertScriptTag;
    exports.getCookie = getCookie;
    exports.registerMessageHandler = registerMessageHandler;
    exports.randomString = randomString;
    exports.evalExpr = evalExpr;
    exports.parsePx = parsePx;
    exports.clickOn = clickOn;
    exports.getInitHierarchy = getInitHierarchy;
    exports.omnitureReady = omnitureReady;
    exports.omnitureTrack = omnitureTrack;
    exports.moveWidget = moveWidget;
    exports._s = _s;
    exports.addStylesMapper = addStylesMapper;
    exports.getOverlay = getOverlay;
    exports.hideModal = hideModal;
    exports.showModal = showModal;

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var I18nMgr = exports.I18nMgr = function () {
        function I18nMgr() {
            _classCallCheck(this, I18nMgr);

            this.cache = {};
            this.currentLocale = null;
            this.customProps = null;
            this._on_success = false;
            this._downloadingCustomProps = false;
            this.currentMap = {};
            this.currentLocaleUrl;
        }

        _createClass(I18nMgr, [{
            key: 'retrieve',
            value: function retrieve(localeUrl, on_success, on_error) {
                var mgr = this;
                mgr._on_success = on_success;
                mgr.currentLocaleUrl = localeUrl;

                // cache hit
                if (mgr.cache.hasOwnProperty(localeUrl)) {
                    mgr.currentLocale = localeUrl;
                    mgr._mergeCustomProps();
                } else {
                    ajax({ url: localeUrl,
                        method: 'GET',
                        success: function success(json) {
                            try {
                                var res = JSON.parse(json);
                                mgr.cache[localeUrl] = res;
                                mgr.currentLocale = localeUrl;
                                mgr._mergeCustomProps();
                            } catch (error) {
                                var exceptionMessage = 'Inside acms retrieve => Exception while downloading content json:' + localeUrl + ':' + error;
                                on_error(exceptionMessage);
                            }
                        },
                        error: function error(_error) {
                            var errorMessage = 'Inside acms retrieve => Error while downloading content json:' + localeUrl + ':' + _error;
                            on_error(errorMessage);
                        }
                    });
                }
            }
        }, {
            key: '_mergeCustomProps',
            value: function _mergeCustomProps() {
                this.currentMap = {};
                if (this.cache.hasOwnProperty(this.currentLocale)) {
                    extend(this.currentMap, this.cache[this.currentLocale]);
                }
                // custom props always overwrite built-in props
                if (this.customProps) {
                    extend(this.currentMap, this.customProps);
                }

                if (this._downloadingCustomProps) {
                    // hold down for the custom props being downloaded.
                } else if (typeof this._on_success === 'function') {
                    var on_success = this._on_success;
                    this._on_success = false;
                    on_success();
                }
            }
        }, {
            key: 'retrieveCustomProps',
            value: function retrieveCustomProps(invokerPropUrl, on_success, on_error) {
                var mgr = this;
                mgr._downloadingCustomProps = true;
                ajax({ url: invokerPropUrl,
                    method: 'GET',
                    success: function success(json) {
                        mgr._downloadingCustomProps = false;
                        try {
                            var res = JSON.parse(json);
                            mgr.customProps = res;
                            mgr._mergeCustomProps();
                        } catch (err) {
                            console.error("fail to download " + invokerPropUrl + ":" + err);
                        }
                    },
                    error: function error(err) {
                        mgr._downloadingCustomProps = false;
                        console.error("fail to download " + invokerPropUrl + ":" + err);
                    }
                });
            }
        }]);

        return I18nMgr;
    }();

    var i18nMgr = new I18nMgr();

    function resetLocales() {
        i18nMgr = new I18nMgr();
    }

    function setCurrentLocale(localeUrl, on_success, on_error) {
        i18nMgr.retrieve(localeUrl, on_success, on_error);
    }

    function getCurrentLocaleUrl() {
        return i18nMgr.currentLocaleUrl;
    }

    function getRes(key) {
        var imap = i18nMgr.currentMap;
        if (imap.hasOwnProperty(key)) {
            return imap[key];
            //}else if(imap.hasOwnProperty(key + '.title')){
            //    return imap[key + '.title'];
        } else {
            console.log("missing string resource of " + key);
            return '';
        }
    }

    function _n(expr, vars) {
        var value = getRes(expr);
        if (vars) {
            value = evalExpr(value, vars);
        }
        return value;
    }

    // invokerProps can be a URL or an object
    function setCustomTextProps(invokerProps) {
        if (!invokerProps) {
            // skip
        } else if (typeof invokerProps === 'string') {
            // URL
            i18nMgr.retrieveCustomProps(invokerProps);
        } else if ((typeof invokerProps === 'undefined' ? 'undefined' : _typeof(invokerProps)) === 'object') {
            i18nMgr.customProps = invokerProps;
            i18nMgr._mergeCustomProps();
        } else if (typeof invokerProps === 'function') {
            i18nMgr.customProps = invokerProps();
            i18nMgr._mergeCustomProps();
        } else {
            throw new Error("Invalid type of " + invokerProps);
        }
    }

    //
    // common utilities
    //
    'use strict';

    function extend(target, src1) {
        if (!target) {
            target = {};
        }

        for (var i = 1; i < arguments.length; i++) {
            var src = arguments[i];
            if (src && (typeof src === 'undefined' ? 'undefined' : _typeof(src)) === 'object') {
                for (var k in src) {
                    if (src.hasOwnProperty(k)) {
                        target[k] = src[k];
                    }
                }
            }
        }
        return target;
    };

    function willChange(target, src) {
        if (src && (typeof src === 'undefined' ? 'undefined' : _typeof(src)) === 'object') {
            for (var k in src) {
                if (src.hasOwnProperty(k)) {
                    if (!(target.hasOwnProperty(k) && src[k] === target[k])) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    function endsWith(str1, str2) {
        if (str1 && str2) {
            var len1 = str1.length;
            var len2 = str2.length;
            return len1 >= len2 && str1.substring(len1 - len2) === str2;
        } else {
            return false;
        }
    }

    function joinUrl(part1, part2) {
        if (!part2) return part1;

        if (part1 && part1.charAt(part1.length - 1) === '/') {
            if (part2 && part2.charAt(0) === '/') {
                return part1 + part2.substring(1);
            } else {
                return part1 + part2;
            }
        } else {
            if (part2 && part2.charAt(0) === '/') {
                return part1 + part2;
            } else {
                return part1 + '/' + part2;
            }
        }
    }

    function joinIfAbsent(part1, part2) {
        if (endsWith(part1, part2) || endsWith(part1, part2 + '/')) {
            return part1; // part1 already ends with part2
        } else {
            return joinUrl(part1, part2);
        }
    }

    function parseHeaders(headsText) {
        var headers = {};
        if (headsText) {
            var lines = headsText.split('\n');
            lines.forEach(function (line) {
                var pos = line.indexOf(': ');
                if (pos > 0) {
                    var k = line.substring(0, pos);
                    var v = line.substring(pos + 2).trim();
                    headers[k] = v;
                }
            });
        }
        return headers;
    }

    function getErrorInResponse(respText) {
        var code = '',
            message = '';
        var m = /code\"\s*:\s*(\d+|\"[^\"]*\")/i.exec(respText);
        if (m) {
            code = m[1].replace(/\"/g, '');
        }

        m = /message\"\s*:\s*\"([^\"]*)\"/i.exec(respText);
        if (m) {
            message = m[1];
        }
        return 'code:' + code + ', message:' + message;
    }

    function ajax(args) {
        //args.method
        var xhttp = new XMLHttpRequest();
        try {
            xhttp.timeout = 600000; // 10 minutes
        } catch (err) {
            // happens in IE
            console.log('warning: can not set timeout.');
        }
        xhttp.withCredentials = args.withCredentials || false;
        xhttp.onreadystatechange = function () {
            if (this.readyState == 4) {
                if (this.status == 200) {
                    var resp = this.responseText;
                    if (typeof args.success === 'function') {
                        var success = args.success;
                        var respHeaders = parseHeaders(this.getAllResponseHeaders());
                        success(resp, respHeaders);
                    }
                } else {
                    console.log(this.status + " " + this.responseText);
                    var message = "HTTP " + this.status + " " + getErrorInResponse(this.responseText);
                    if (typeof args.error === 'function') {
                        args.error(message);
                    }
                }
            }
        };

        if (typeof args.error === 'function') {
            xhttp.onerror = args.error;
        }

        xhttp.open(args.method, args.url, true);

        if (args.hasOwnProperty('headers') && _typeof(args.headers) === 'object' && args.headers) {
            for (var k in args.headers) {
                if (args.headers.hasOwnProperty(k)) {
                    xhttp.setRequestHeader(k, args.headers[k]);
                }
            }
        }
        xhttp.send(args.data);
    }

    /**
     * @param {object} args
     *    {
     *         url  : the service url
     *         file : the file to upload,
     *         formFields:  form fields,
     *         headers: request headers
     *         success: on_success callback,
     *         error: on_error callback,
     *         progress: on_progress callback
     *    }
     */
    function upload(args) {
        var url = args.url;
        var file = args.file;
        var formFields = args.formFields;
        var on_success = args.success;
        var on_error = args.error;
        var on_progress = args.progress;

        var xhttp = new XMLHttpRequest();
        try {
            xhttp.timeout = 600000; // 10 minutes
        } catch (err) {
            // happens in IE
            console.log('warning: can not set timeout.');
        }
        xhttp.file = file;

        if (xhttp.upload) {
            if (typeof on_error === 'function') {
                xhttp.upload.onerror = on_error;
            }

            if (typeof on_progress === 'function') {
                xhttp.upload.onprogress = on_progress;
            }

            xhttp.upload.onabort = function (e) {
                if (typeof on_error === 'function') {
                    on_error("aborted");
                }
            };
        } else {
            if (typeof on_error === 'function') {
                xhttp.onerror = on_error;
            }
        }

        xhttp.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    try {
                        if (typeof on_success === 'function') {
                            var respHeaders = parseHeaders(this.getAllResponseHeaders());
                            on_success(file, this.responseText, respHeaders);
                        }
                    } catch (err) {
                        if (typeof on_error === 'function') {
                            on_error(err);
                        }
                    }
                } else {
                    console.log(this.status + " " + this.responseText);
                    var message = "HTTP " + this.status + " " + getErrorInResponse(this.responseText);
                    if (typeof on_error === 'function') {
                        on_error(message);
                    }
                }
            }
        };

        var formData = new FormData();
        if ((typeof formFields === 'undefined' ? 'undefined' : _typeof(formFields)) === 'object' && formFields) {
            for (var key in formFields) {
                if (formFields.hasOwnProperty(key)) {
                    formData.append(key, formFields[key]);
                }
            }
        }
        formData.append("file", file);
        xhttp.open("POST", url, true);

        if (_typeof(args.headers) === 'object' && args.headers) {
            for (var k in args.headers) {
                if (args.headers.hasOwnProperty(k)) {
                    xhttp.setRequestHeader(k, args.headers[k]);
                }
            }
        }
        xhttp.send(formData);
    }

    function download(url) {
        var xhttp = new XMLHttpRequest();
        xhttp.open("GET", url, false);
        xhttp.send(null);

        if (xhttp.status === 200) {
            return xhttp.responseText;
        } else {
            throw Error('Fail to download (' + xhttp.status + ') ' + xhttp.statusText);
        }
    }

    function insertStylesheetLink(url) {
        var found = false;
        var elems = document.getElementsByTagName("link");
        for (var elem in elems) {
            if (elem.ref === "stylesheet" && elem.href === url) {
                found = true;
            }
        }
        if (found) {
            return; // the CSS link already exists.
        }

        var head = document.head || document.getElementsByTagName("head")[0];

        var linkElement = document.createElement("link");
        linkElement.rel = "stylesheet";
        linkElement.type = "text/css";
        linkElement.href = url;
        linkElement.crossorigin = 'anonymous';
        head.appendChild(linkElement);

        return linkElement;
    }

    function insertScriptTag(url, type) {
        var found = false;
        var elems = document.getElementsByTagName("script");
        for (var elem in elems) {
            if (elem.src === url) {
                found = true;
            }
        }
        if (found) {
            return; // the script tag already exists.
        }

        var head = document.head || document.getElementsByTagName("head")[0];

        var scriptElement = document.createElement("script");
        scriptElement.type = type || "text/javascript";
        scriptElement.src = url;
        head.appendChild(scriptElement);

        return scriptElement;
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function registerMessageHandler(handler) {
        // Create IE + others compatible event handler
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

        // Listen to message from child window
        eventer(messageEvent, handler, false);
    }

    function randomString(len) {
        var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345679';
        var s = '';
        for (var i = 0; i < len; i++) {
            s = s + CHARS.charAt(Math.round(CHARS.length * Math.random()) % CHARS.length);
        }
        return s;
    }

    function inArray(arr, obj) {
        return arr.indexOf(obj) !== -1;
    }

    function mergeArray(arr1, arr2) {
        if (typeof arr2 !== 'undefined') {
            if (Array.isArray(arr2)) {
                for (var i = 0; i < arr2.length; i++) {
                    var item = arr2[i];
                    if (!inArray(arr1, item)) {
                        arr1.push(item);
                    }
                }
            } else {
                var item = arr2;
                if (!inArray(arr1, item)) {
                    arr1.push(item);
                }
            }
        }
        return arr1;
    }

    /**
     * Evaluate Angular-like expression in a string
     *  {{ expr }}
     * @param {String} fmt
     * @param {Object} value
     * @return {String} result
     */
    function evalExpr(fmt, value) {
        return fmt.replace(/\{\{([^\{\}]*)\}\}|\@\{([^\{\}]*)\}/g, function (m0, m1, m2) {
            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value) {
                var expr = (m1 || m2).trim();
                var obj = value;
                var arr = expr.split('.');
                while (arr.length) {
                    var field = arr.shift();
                    if (obj.hasOwnProperty(field)) {
                        obj = obj[field];
                    } else {
                        return '';
                    }
                }
                return obj;
            } else {
                return '';
            }
        });
    }

    function parsePx(str) {
        if (typeof str === 'number') {
            return str;
        }

        var len = 0;
        var m = /(\d+(?:\.\d*)?)\s*(px|pt|pc|in|cm|mm|em|ex|\%)?/i.exec(str);
        if (m) {
            var num = m[1];
            var unit = m[2] ? m[2].toLowerCase() : '';
            len = num.indexOf('.') >= 0 ? parseFloat(num) : parseInt(num);
            // convert to px
            if (unit === 'pt') {
                len = len * 96 / 72;
            } else if (unit === 'pc') {
                len *= 16;
            } else if (unit === 'in') {
                len *= 96;
            } else if (unit === 'cm') {
                len *= 38;
            } else if (unit === 'mm') {
                len *= 3.8;
            } else if (unit === 'em') {
                len *= 16; //?
            } else if (unit === 'ex') {
                len *= 16; //?
            }
        }
        return len;
    }

    function clickOn(elemOrId) {
        var btn;
        if (typeof elemOrId === 'string') {
            btn = document.getElementById(elemOrId);
        } else {
            btn = elemOrId;
        }
        if (!btn) {
            throw new Error("Fail to find element " + elemOrId);
        }
        var evt = document.createEvent("MouseEvents");
        evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        return btn.dispatchEvent(evt);
    }

    // race condition fix
    var omn_queue = [];
    var omn_counter = 0;
    var pageTrackerTimer = null;
    function startOmnSender() {
        if (!pageTrackerTimer) {
            pageTrackerTimer = setInterval(function () {
                if (omn_counter < 3600000) {
                    omn_counter += 500;
                }

                // safe now or time out, send the queue
                var nextOmn;
                while (omnitureReady() && (nextOmn = omn_queue.shift())) {
                    invokeOmn(nextOmn);
                }

                // if the queue is clean
                if (omn_queue.length === 0) {
                    stopOmnSender();
                }
            }, 500);
        }
    }

    function stopOmnSender() {
        if (pageTrackerTimer) {
            clearInterval(pageTrackerTimer);
            pageTrackerTimer = null;
        }
    }

    function invokeOmnLater(newOmn) {
        omn_queue.push(newOmn);
        startOmnSender();
    }

    var _omn_fields = ['events', 'products', 'pcnnumber', 'appconfig', 'eVar41'];
    var _omn_global_fields = ['omn', 'omn_events', 'omn_products', 'omn_pcnnumber', 'omn_appconfig'];
    var initHierarchy = '';

    function getInitHierarchy() {
        return initHierarchy;
    }

    function invokeOmn(newOmn) {
        var savedGlobals = {},
            field,
            i;

        if (!initHierarchy) {
            if (window.omn && _typeof(window.omn) === 'object') {
                if (window.omn['hierarchy']) {
                    initHierarchy = window.omn['hierarchy'];
                } else if (window.omn['ppvpage']) {
                    initHierarchy = window.omn['ppvpage'].replace(/\|[^\|]*$/, '');
                }
            }
        }

        // save the global variables
        // clearEvents
        for (i = 0; i < _omn_global_fields.length; i++) {
            field = _omn_global_fields[i];
            savedGlobals[field] = window[field];
            if (typeof window[field] !== 'undefined') {
                window[field] = '';
            }
        }

        for (i = 0; i < _omn_fields.length; i++) {
            field = _omn_fields[i];
            s[field] = '';
        }

        if (initHierarchy) {
            newOmn.hierarchy = initHierarchy; //initVar41.replace(/\|[^\|]*$/,'');
        }
        // use the new omn object
        window.omn = newOmn;
        var s_code = s.t();

        // recover the global variables
        for (i = 0; i < _omn_global_fields.length; i++) {
            field = _omn_global_fields[i];
            window[field] = savedGlobals[field];
        }
        return s_code;
    }

    function omnitureReady() {
        if (window.pageTrackFired || omn_counter >= 10000) {
            return (typeof s === 'undefined' ? 'undefined' : _typeof(s)) === 'object' && s && s.isReadyToTrack();
        } else {
            return false;
        }
    }

    function omnitureTrack(newOmn) {
        try {
            if (typeof s === 'undefined' || typeof s.t !== 'function' || typeof s.isReadyToTrack !== 'function') {
                console.log("Omniture tracking is unavailable.");
                return;
            }
            if (!window) {
                console.log("window object is unavailable.");
                return;
            }

            // race condition check
            if (omnitureReady()) {
                //console.log("invokeOmn " + JSON.stringify(newOmn));
                return invokeOmn(newOmn);
            } else {
                //console.log("invokeOmnLater " + JSON.stringify(newOmn));
                invokeOmnLater(newOmn);
                return;
            }
        } catch (err) {
            console.log("omnitureTrack error:" + err);
            return err;
        }
    }

    "use strict";

    // Reactlite -- a lightweight pure JS simulator of React

    var didMountComps = [];

    function isLower(c) {
        return 'a' <= c && c <= 'z';
    }

    function _React$Component(props) {
        this.props = props || {};
        this.refs = {};
    }

    _React$Component.prototype = {
        setState: function setState(newState) {
            if (!this.state) this.state = {};

            var changed = willChange(this.state, newState);
            this.state = extend(this.state, newState);
            if (changed) {
                this.forceUpdate();
            }
        },

        forceUpdate: function forceUpdate() {
            var comp = this;
            setTimeout(function () {
                comp._redraw();
            }, 100);
        },

        getElement: function getElement() {
            if (isReactComponent(this.content)) {
                // wrapper object
                return this.content.getElement();
            } else {
                // simple html element
                return this.content;
            }
        },

        _redraw: function _redraw() {
            var oldElem = this.getElement();
            if (oldElem) {
                var savedCurrDoc = ReactLite.currentDocument;
                // rendering in the original owner document
                ReactLite.currentDocument = oldElem.ownerDocument;
                var newContent = this.render();
                ReactLite.currentDocument = savedCurrDoc;

                var newElem = _getElement(newContent);
                if (oldElem.parentElement) {
                    oldElem.parentElement.replaceChild(newElem, oldElem);
                    this.content = newElem;

                    while (didMountComps.length > 0) {
                        var comp = didMountComps.shift();
                        if (comp) {
                            comp.componentDidMount();
                        }
                    }
                } else {
                    console.log("Warning: Element " + oldElem + " <" + oldElem.tagName + "> doesn't have a parent.");
                }
            }
        }
    };

    function isReactComponent(comp) {
        return comp && (comp instanceof _React$Component || _React$Component.isPrototypeOf(comp));
    }

    function _getElement(comp) {
        if (isReactComponent(comp)) {
            return comp.getElement();
        } else {
            return comp;
        }
    }

    function _flatArray(arr, startIdx, endIdx) {
        if (typeof startIdx === 'undefined') {
            startIdx = 0;
        }
        if (typeof endIdx === 'undefined') {
            endIdx = arr.length;
        }
        var newArr = [];
        for (var i = startIdx; i < endIdx; i++) {
            var item = arr[i];
            if (item) {
                if (Array.isArray(item)) {
                    for (var j = 0; j < item.length; j++) {
                        newArr.push(item[j]);
                    }
                } else {
                    newArr.push(item);
                }
            }
        }
        return newArr;
    }

    function _createElement(elemType, props) {
        var elem;
        var comp;
        var doc = ReactLite.currentDocument || document;
        var children = _flatArray(arguments, 2);
        // simple html tag
        if (typeof elemType === 'string' && isLower(elemType.charAt(0))) {
            if (props && props.hasOwnProperty("xmlns")) {
                elem = doc.createElementNS(props.xmlns, elemType);
            } else {
                elem = doc.createElement(elemType);
            }
            // set attributes
            if (props && (typeof props === 'undefined' ? 'undefined' : _typeof(props)) === 'object') {
                Object.keys(props).forEach(function (key) {
                    if (key !== 'xmlns') {
                        var value = props[key];
                        if (key.toLowerCase() === 'classname') {
                            key = 'class';
                            value = _s(value); // styles mapping
                        }
                        if (typeof value === 'function') {
                            if (key.lastIndexOf('on', 0) === 0) {
                                key = key.substring(2).toLowerCase();
                            }
                            elem.addEventListener(key, value);
                        } else {
                            if (key === 'style' && value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
                                var s = '';
                                Object.keys(value).forEach(function (k) {
                                    if (k) {
                                        s += k + ':' + value[k] + ';';
                                    }
                                });
                                value = s;
                                elem.setAttribute(key, value);
                            } else if (key === 'disabled' || key === 'checked') {
                                if (value) {
                                    elem.setAttribute(key, key);
                                } else {
                                    elem.removeAttribute(key);
                                }
                            } else {
                                if (typeof value !== 'undefined' && value !== '') {
                                    elem.setAttribute(key, value);
                                }
                            }
                        }
                    }
                });
            }

            // adding children
            for (var i = 0; i < children.length; i++) {
                var arg = children[i];
                if (typeof arg === 'string') {
                    var node = doc.createTextNode(arg);
                    elem.appendChild(node);
                } else if (arg) {
                    elem.appendChild(_getElement(arg));
                } // ignore other type of items
            }
            return elem;
        }
        // custom tag
        else if (typeof elemType === 'function') {
                if (_React$Component.isPrototypeOf(elemType)) {
                    // React.Component
                    props = props || {};
                    props.children = children;
                    comp = new elemType(props || {});

                    if (typeof comp.componentWillMount === 'function') {
                        comp.componentWillMount();
                    }

                    comp.content = comp.render();

                    /*
                    if(comp.content instanceof HTMLElement && children){
                        for(var i=0;i<children.length;i++){
                            var arg = children[i];
                            if(typeof arg === 'string'){
                                var node = document.createTextNode(arg);
                                comp.content.appendChild(node);
                            }else if(arg){
                                comp.content.appendChild(_getElement(arg));
                            }// ignore other type of items
                        }
                    }
                    */

                    // set up comp.refs
                    _traverseChildren(comp, function (subComp) {
                        if (isReactComponent(subComp)) {
                            var ref = subComp.props.ref;
                            if (ref) {
                                comp.refs[ref] = subComp.getElement();
                            }
                        } else {
                            if (subComp.hasAttribute('ref')) {
                                var ref = subComp.getAttribute('ref');
                                comp.refs[ref] = subComp;
                                subComp.removeAttribute('ref');
                            }
                        }
                    });

                    // saving the comp for later invocation of componentDidMount
                    if (typeof comp.componentDidMount === 'function') {
                        didMountComps.push(comp);
                    }
                    return comp;
                } else {
                    // pure function
                    props = props || {};
                    props.children = children;
                    comp = elemType(props);
                    // adding children
                    return comp;
                }
            } else {
                throw new Error("Invalid type of " + (typeof elemType === 'undefined' ? 'undefined' : _typeof(elemType)));
            }
    }

    function _createClassForES5(compDef) {
        var CompType = function (_React$Component2) {
            _inherits(CompType, _React$Component2);

            function CompType(props) {
                _classCallCheck(this, CompType);

                var _this = _possibleConstructorReturn(this, (CompType.__proto__ || Object.getPrototypeOf(CompType)).call(this, props));

                if (typeof compDef.getInitialState === 'function') {
                    _this.state = compDef.getInitialState.call(_this);
                }
                return _this;
            }

            _createClass(CompType, [{
                key: 'render',
                value: function render() {
                    if (typeof compDef.render === 'function') {
                        return compDef.render.call(this);
                    } else {
                        throw new Error('render function not defined.');
                    }
                }
            }]);

            return CompType;
        }(React.Component);

        return CompType;
    }

    function cleanChildren(elem) {
        while (elem && elem.lastChild) {
            elem.removeChild(elem.lastChild);
        }
    }

    function _traverseChildren(comp, cb) {
        if (comp) {
            if (isReactComponent(comp)) {
                cb(comp);
                _traverseChildren(comp.content, cb);
            } else if (comp instanceof HTMLElement) {
                cb(comp);

                var subElem = comp.firstChild;
                while (subElem) {
                    if (subElem instanceof HTMLElement) {
                        _traverseChildren(subElem, cb);
                    }
                    subElem = subElem.nextSibling;
                }
            }
        }
    }

    function _renderDom(comp, container, append) {
        if (!append) {
            cleanChildren(container);
        }
        container.appendChild(_getElement(comp));

        while (didMountComps.length > 0) {
            var comp = didMountComps.shift();
            if (comp) {
                comp.componentDidMount();
            }
        }
    }

    function moveWidget(comp, container) {
        cleanChildren(container);
        container.appendChild(_getElement(comp));
    }

    var React = exports.React = {
        createElement: _createElement,
        createClass: _createClassForES5,
        Component: _React$Component,
        PropTypes: {
            object: {
                isRequired: 'required_object'
            },
            number: {
                isRequired: 'required_number'
            },
            string: {
                isRequired: 'required_string'
            },
            bool: {
                isRequired: 'required_bool'
            },
            func: {
                isRequired: "required_func"
            },
            node: {
                isRequired: "required_node"
            },
            oneOfType: function oneOfType(arr) {
                return { "oneOf": arr };
            },
            arrayOf: function arrayOf(node) {
                return { "arrayOf": node };
            }
        }
    };

    var ReactDOM = exports.ReactDOM = {
        render: _renderDom,
        findDOMNode: _getElement
    };

    // helpers
    var ReactLite = exports.ReactLite = {
        isReactComponent: isReactComponent,
        traverseChildren: _traverseChildren,
        moveWidget: moveWidget,
        currentDocument: null
    };
    "use strict";

    var stylesMappers = []; // a chain of styles mappers each of which can be an object or a function

    function _s(className) {
        if (!className) return className;
        return className.replace(/[\w\-\_@#]+/g, function (c) {
            for (var i = 0; i < stylesMappers.length; i++) {
                var m = stylesMappers[i];
                if (typeof m === 'function') {
                    var v = m(c);
                    if (v) {
                        // if the function returns non-trivial value
                        return c + ' ' + v;
                    }
                } else if (m && (typeof m === 'undefined' ? 'undefined' : _typeof(m)) === 'object') {
                    if (m.hasOwnProperty(c)) {
                        return c + ' ' + m[c];
                    }
                }
            }

            // none of the mappers matches
            return c;
        });
    }

    function addStylesMapper(m) {
        if (m && m.styles && _typeof(m.styles) === 'object') {
            m = m.styles;
        }

        stylesMappers.unshift(m);
    }

    var AccordionPanel = exports.AccordionPanel = function (_React$Component3) {
        _inherits(AccordionPanel, _React$Component3);

        function AccordionPanel(props) {
            _classCallCheck(this, AccordionPanel);

            return _possibleConstructorReturn(this, (AccordionPanel.__proto__ || Object.getPrototypeOf(AccordionPanel)).call(this, props));
        }

        _createClass(AccordionPanel, [{
            key: 'render',
            value: function render() {
                var _props = this.props,
                    name = _props.name,
                    title = _props.title,
                    expanded = _props.expanded,
                    shown = _props.shown,
                    onSelect = _props.onSelect,
                    renderExpanded = _props.renderExpanded,
                    renderCollapsed = _props.renderCollapsed;

                if (shown) {
                    if (expanded) {
                        return React.createElement(
                            'div',
                            {
                                className: 'infw-accordion-border infw-open',
                                role: 'listitem' },
                            React.createElement(
                                'div',
                                { className: 'infw-accordion-header',
                                    onClick: function onClick() {
                                        if (onSelect) onSelect(name);
                                    } },
                                React.createElement(
                                    'span',
                                    {
                                        className: 'dls-glyph-down',
                                        'aria-expanded': expanded,
                                        role: 'button' },
                                    title
                                )
                            ),
                            React.createElement(
                                'div',
                                { className: 'infw-accordion-content' },
                                renderExpanded()
                            )
                        );
                    } else {
                        return React.createElement(
                            'div',
                            {
                                className: 'infw-accordion-border infw-close',
                                role: 'listitem' },
                            React.createElement(
                                'div',
                                { className: 'infw-accordion-header',
                                    onClick: function onClick() {
                                        if (onSelect) onSelect(name);
                                    } },
                                React.createElement(
                                    'span',
                                    {
                                        className: 'dls-glyph-right',
                                        onKeyDown: function onKeyDown(e) {
                                            if (e.keyCode === 32 && onSelect) onSelect(name)
                                        },
                                        'tabindex': 0,
                                        'aria-expanded': expanded,
                                        'aria-label': 'toggle button for collapsible accordion',
                                        role: 'button' },
                                    title
                                )
                            ),
                            renderCollapsed ? React.createElement(
                                'div',
                                { className: 'infw-accordion-content' },
                                renderCollapsed()
                            ) : false
                        );
                    }
                } else {
                    return React.createElement('div', null); // place holder
                }
            }
        }]);

        return AccordionPanel;
    }(React.Component);

    ;

    AccordionPanel.propTypes = {
        name: React.PropTypes.string.isRequired,
        title: React.PropTypes.string.isRequired,
        expanded: React.PropTypes.bool,
        shown: React.PropTypes.bool,
        onSelect: React.PropTypes.func,
        renderExpanded: React.PropTypes.func.isRequired,
        renderCollapsed: React.PropTypes.func,
        children: React.PropTypes.oneOfType([React.PropTypes.arrayOf(React.PropTypes.node), React.PropTypes.node])
    };

    var Accordion = exports.Accordion = function (_React$Component4) {
        _inherits(Accordion, _React$Component4);

        function Accordion(props) {
            _classCallCheck(this, Accordion);

            var _this3 = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

            _this3.state = { active: _this3.props.active };
            return _this3;
        }

        _createClass(Accordion, [{
            key: 'nav',
            value: function nav(panel) {
                if (this.state.active === panel) {
                    this.setState({ active: null });
                } else {
                    this.setState({ active: panel });
                    if (typeof this.props.onSelect === 'function') {
                        this.props.onSelect.call(this, panel);
                    }
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this4 = this;

                var panels = [];
                this.props.children.forEach(function (child) {
                    mergeArray(panels, child);
                });

                var children = [];
                panels.forEach(function (panel) {
                    if (panel instanceof AccordionPanel) {
                        var panelName = panel.props.name;
                        panel.props.shown = true;
                        panel.props.expanded = panelName === _this4.state.active;
                        panel.props.onSelect = _this4.nav.bind(_this4);

                        children.push(panel.render());
                    } else {
                        throw new Error("AccordionPanel is required in an Accordion");
                    }
                });

                return React.createElement(
                    'div',
                    {
                        id: this.props.id,
                        className: this.props.className,
                        style: this.props.style,
                        role: 'list'
                    },
                    children
                );
            }
        }]);

        return Accordion;
    }(React.Component);

    Accordion.propTypes = {
        id: React.PropTypes.string,
        className: React.PropTypes.string,
        style: React.PropTypes.object
    };

    var ELEM_ID_OVERLAY_PREFIX = exports.ELEM_ID_OVERLAY_PREFIX = 'px_widget_overlay_';
    var ELEM_ID_OVERLAY_BOX_PREFIX = exports.ELEM_ID_OVERLAY_BOX_PREFIX = 'px_widget_overlay_box_';
    var OVERLAY_ZINDEX_BASE = exports.OVERLAY_ZINDEX_BASE = 99990;
    var LEVEL_OVERLAY = exports.LEVEL_OVERLAY = 1;
    var LEVEL_DIALOG = exports.LEVEL_DIALOG = 9;
    var OVERLAY_PERCENTAGE = exports.OVERLAY_PERCENTAGE = 0.9;

    var Overlay = exports.Overlay = function (_React$Component5) {
        _inherits(Overlay, _React$Component5);

        function Overlay(props) {
            _classCallCheck(this, Overlay);

            var _this5 = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));

            _this5.compContent = null;
            _this5.visible = props.visible || false;
            _this5.zIndex = props.zIndex || 99990;
            return _this5;
        }

        _createClass(Overlay, [{
            key: 'renderBox',
            value: function renderBox() {
                return this.compContent;
            }
        }, {
            key: 'render',
            value: function render() {
                var width = this.visible ? window.innerWidth : 0;
                var height = this.visible ? window.innerHeight : 0;

                return React.createElement(
                    'div',
                    { id: this.props.id,
                        className: 'infw-modal-wrapper',
                        style: {
                            position: 'fixed',
                            'z-index': this.zIndex,
                            display: this.visible ? 'block' : 'none',
                            top: '0px',
                            left: '0px',
                            right: width + 'px',
                            bottom: height + 'px',
                            background: 'rgba(0, 0, 0, 0.3)'
                        } },
                    React.createElement(
                        'div',
                        { ref: 'contentBox', id: this.props.boxId,
                            className: this.props.className },
                        this.renderBox()
                    )
                );
            }
        }]);

        return Overlay;
    }(React.Component);

    function resizeOverlay(elemBase, elemBox) {
        // resize for overlay, not dialog
        if (elemBase.style.display === 'block' && elemBase.style.position === 'absolute') {
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;

            elemBase.style.right = windowWidth;
            elemBase.style.bottom = windowHeight;

            var width = windowWidth * OVERLAY_PERCENTAGE;
            var height = windowHeight * OVERLAY_PERCENTAGE;
            elemBox.style['margin-left'] = -width / 2 + 'px';
            elemBox.style['margin-top'] = -height / 2 + 'px';
            elemBox.style.width = elemBox.style['min-width'] = width + 'px';
            elemBox.style.height = elemBox.style['min-height'] = height + 'px';
        }
    }

    function getOverlay(overlayLevel, createNew) {
        var elemId = ELEM_ID_OVERLAY_PREFIX + overlayLevel;
        var elemOverlay = document.getElementById(elemId),
            elemBox = null;
        if (elemOverlay) {
            elemBox = document.getElementById(ELEM_ID_OVERLAY_BOX_PREFIX + overlayLevel);
        } else {
            if (createNew) {
                var zIndex = OVERLAY_ZINDEX_BASE + overlayLevel;
                var isOverlay = zIndex !== LEVEL_DIALOG;

                var overlay = React.createElement(Overlay, { id: elemId,
                    boxId: ELEM_ID_OVERLAY_BOX_PREFIX + overlayLevel,
                    visible: false,
                    className: isOverlay ? 'infw-modal-overlay' : 'infw-modal-dialog',
                    zIndex: zIndex });

                var container = document.getElementById('widget_root');
                if (container) {
                    ReactDOM.render(overlay, container, true);
                } else {
                    ReactDOM.render(overlay, document.body, true);
                }
                elemOverlay = ReactDOM.findDOMNode(overlay);
                elemBox = overlay.refs.contentBox;

                window.addEventListener("resize", function (evt) {
                    resizeOverlay(elemOverlay, elemBox);
                });
            }
        }
        if (elemOverlay && elemBox) {

            return {
                base: elemOverlay,
                box: elemBox
            };
        } else {
            console.log("Fail to find the overlay.");
            return null;
        }
    }

    function hideModal(overlayLevel) {
        var overlay = getOverlay(overlayLevel);
        if (overlay) {
            overlay.base.style.display = 'none';
            overlay.base.style.right = overlay.base.style.left;
            overlay.base.style.bottom = overlay.base.style.top;
        }
    }

    function showModal(comp, overlayLevel) {
        overlayLevel = overlayLevel || LEVEL_DIALOG;
        var overlay = getOverlay(overlayLevel, true);

        if (!overlay) {
            throw new Error("Fail to create overlay of level " + overlayLevel);
        }

        // show it
        var elemBase = overlay.base;
        var elemBox = overlay.box;

        elemBase.style.display = "block";

        elemBox.style.position = 'relative';
        elemBox.style.left = '50%';
        elemBox.style.top = '50%';

        if (overlayLevel === LEVEL_DIALOG) {
            elemBase.style.position = 'fixed';

            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            elemBase.style.right = windowWidth;
            elemBase.style.bottom = windowHeight;

            var width = 600;
            var height = 300;
            if (comp.props.width) {
                width = parsePx(comp.props.width);
            } else if (comp.props.style && comp.props.style.width) {
                width = parsePx(comp.props.style.width);
            }
            if (width > windowWidth) {
                width = windowWidth;
            }

            if (comp.props.height) {
                height = parsePx(comp.props.height);
            } else if (comp.props.style && comp.props.style.height) {
                height = parsePx(comp.props.style.height);
            }
            if (height > windowHeight) {
                height = windowHeight;
            }

            elemBox.style['margin-left'] = -width / 2 + 'px';
            elemBox.style['margin-top'] = -height / 2 + 'px';
            elemBox.style.width = elemBox.style['min-width'] = width + 'px';
            elemBox.style.height = elemBox.style['min-height'] = height + 'px';
        } else {
            elemBase.style.position = 'absolute';

            resizeOverlay(elemBase, elemBox);
        }

        ReactDOM.render(comp, elemBox);
    }

    var WidgetApp = exports.WidgetApp = function (_React$Component6) {
        _inherits(WidgetApp, _React$Component6);

        function WidgetApp(props) {
            _classCallCheck(this, WidgetApp);

            var _this6 = _possibleConstructorReturn(this, (WidgetApp.__proto__ || Object.getPrototypeOf(WidgetApp)).call(this, props));

            _this6.pages = {};
            return _this6;
        }

        _createClass(WidgetApp, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var _this7 = this;

                var resourceUrl = this.getTextResourceUrl();
                if (resourceUrl) {
                    setCurrentLocale(resourceUrl, function () {
                        _this7.onResourcesLoaded();
                    }, function (err) {
                        _this7.showError(err);
                    });
                }
            }
        }, {
            key: 'addPage',
            value: function addPage(pageName, pageClass, props) {
                this.pages[pageName] = { pageClass: pageClass, props: props };
            }
        }, {
            key: 'nav',
            value: function nav(pageName) {
                // to trigger rendering
                this.setState({ pageName: pageName });
            }
        }, {
            key: 'onResourcesLoaded',
            value: function onResourcesLoaded() {
                console.log("Resources ready.");
            }
        }, {
            key: 'showError',
            value: function showError(err) {
                console.log(err);
            }
        }, {
            key: 'onClose',
            value: function onClose(evt) {
                console.log("WARN: not implemented.");
            }
        }, {
            key: 'getTextResourceUrl',
            value: function getTextResourceUrl() {
                throw new Error('getTextResourceUrl() not implemented');
            }
        }, {
            key: 'render',
            value: function render() {

                var page = this.pages[this.state.pageName];
                if ((typeof page === 'undefined' ? 'undefined' : _typeof(page)) !== 'object') {
                    throw new Error('Invalid page ' + this.state.pageName);
                }
                var props = extend({
                    widget: this,
                    onClose: this.onClose.bind(this)
                }, page.props);
                var pageComp = React.createElement(page.pageClass, props);

                return React.createElement(
                    'div',
                    { id: this.props.id,
                        className: this.props.className,
                        style: this.props.style },
                    pageComp
                );
            }
        }]);

        return WidgetApp;
    }(React.Component);

    WidgetApp.propTypes = {
        config: React.PropTypes.object.isRequired
    };
});



//////////////////
// WEBPACK FOOTER
// ./pex-ui/lib/pexui.js
// module id = 2
// module chunks = 0